import React from "react";
import LegalPage from "./LegalPage";

const sections = [
  {
    heading: "Overview",
    body: [
      "Due to the customised and digital nature of our services, all sales are considered final once work has commenced.",
    ],
  },
  {
    heading: "Non-Refundable Services",
    body: [
      "Business setup services, consultations, templates, systems, and digital products are non-refundable.",
    ],
  },
  {
    heading: "Before Work Begins",
    body: [
      "If a client cancels before work has started, a partial refund may be considered at our discretion. Any completed consultation time, preparation work, administrative costs, or processing fees will be deducted from the refund amount.",
      "Consultation sessions are non-refundable once completed.",
    ],
  },
  {
    heading: "Client Delays",
    body: [
      "If a client becomes unresponsive for more than 30 days, the project may be paused or closed without refund.",
    ],
  },
  {
    heading: "Physical Items",
    body: [
      "Where physical branded materials are included, damaged items must be reported within 7 days of delivery.",
    ],
  },
  {
    heading: "Contact",
    body: [],
    contact: "info@thefoundationedit.co.uk",
  },
];

export default function Refund() {
  return (
    <LegalPage
      overline="Legal"
      title="Refund Policy"
      lastUpdated="April 2026"
      sections={sections}
    />
  );
}
